import { Table } from '@/components/multiplier_type/table'

export const ChargeMultipliers = () => {
  return (
    <>
      <Table createable onIndex />
    </>
  )
}
